import axios from "axios";

// Domaine personnalisé (ex. constat.madlo.ch) : l'API est servie sur la même origine → cookies first-party.
const sameOrigin = typeof window !== "undefined" && window.location.protocol === "https:" && !window.location.hostname.endsWith("emergentagent.com") && !window.location.hostname.endsWith("emergent.host");
const BACKEND_URL = sameOrigin ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Rafraîchissement automatique du jeton d'accès (15 min) : une seule requête de refresh à la fois, puis rejeu.
let refreshing = null;
api.interceptors.response.use(undefined, async (error) => {
  const { config, response } = error;
  const url = config?.url || "";
  if (response?.status !== 401 || config._retry || url.startsWith("/auth/") || url.startsWith("/public/")) throw error;
  config._retry = true;
  try {
    refreshing = refreshing || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
    await refreshing;
  } catch (e) {
    window.dispatchEvent(new CustomEvent("madlo:session-expiree"));
    throw error;
  }
  return api(config);
});

export const isAuthError = (err) => err?.response?.status === 401;

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
